module.exports = __webpack_public_path__ + "img/ring_g_e_1_null@2x.4b4e238f.png";